import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';
import './Icon_type_comment.css';

export interface WithTypeCommentProps {
  type?: 'comment';
}

export const withTypeComment = withBemMod<WithTypeCommentProps>(
    'Icon',
    { type: 'comment' },
    (Icon): FC => ((props): ReactElement => (<Icon {...props} />)),
);

export default withTypeComment;
